export default {"src":"/_next/static/media/arrow-right.6a49ed15.svg","height":26,"width":13,"blurWidth":0,"blurHeight":0};